import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { DEFAULT_ERROR_MESSAGE } from '@/constants/app/config';
import { useEditRestockMutation } from '@/store/api/services/restocking/restocking';
import { RestockRequestStatus } from '@/types/generated/boro';

import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

const FulfillLoadOrder = ({ props, hide }: ModalChildrenProps) => {
  const id = props?.id;
  const [editRestock, { isLoading }] = useEditRestockMutation();
  const [bagId, setBagId] = useState<string>('');

  const isValid = bagId.length > 3;

  const handleSubmit = async () => {
    try {
      await editRestock({
        id,
        data: { status: RestockRequestStatus.Fulfilled, loaded_bag_id: bagId },
      }).unwrap();
      hide();
      toast.success('Load Order fulfilled successfully');
    } catch (error) {
      toast.error((error as any).message ?? DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <>
      <DialogContent>
        <Stack gap={2} py={3}>
          <Typography>
            Once you fulfill this order, it can no longer be edited. However, you'll still be able
            to create adjustments later if needed.
          </Typography>

          <Box>
            <Typography variant="h6" mb={1}>
              Load Bag ID *
            </Typography>
            <TextField
              onChange={({ target }) => setBagId(target.value.toUpperCase())}
              placeholder="Bag ID"
              disabled={isLoading}
              value={bagId}
              fullWidth
            />
          </Box>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={hide}>Cancel</Button>
        <LoadingButton
          disabled={!isValid}
          loading={isLoading}
          onClick={handleSubmit}
          variant="contained"
        >
          Fulfill
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default FulfillLoadOrder;
